import { create } from "zustand";
import { IGlobalNotification, INotification } from "interfaces/Notifications";

interface INotificationsStore {
  personalNotificationsArr: INotification[] | [];
  globalNotificationsArr: IGlobalNotification[] | [];
  saveNotifications: (notofications: INotification[]) => void;
  saveGlobalNotifications: (notofications: IGlobalNotification[]) => void;
}

const useNotificationsStore = create<INotificationsStore>((set) => ({
  personalNotificationsArr: [],
  globalNotificationsArr: [],
  saveNotifications: (notofications) => set({ personalNotificationsArr: notofications }),
  saveGlobalNotifications: (globalNotifications) => set({ globalNotificationsArr: globalNotifications }),
}));

export { useNotificationsStore };
